import translationsEn from "../../translations/en.json";
import translationsNo from "../../translations/no.json";
import { useSelector } from "react-redux";
import { useEffect, useState, useMemo } from "react";

export function useTranslations() {
  const { language } = useSelector((state) => state.global);
  const [delayedLanguage, setDelayedLanguage] = useState(language);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setDelayedLanguage(language);
    }, 300);

    return () => clearTimeout(timeout);
  }, [language]);

  const t = useMemo(() => {
    return delayedLanguage === "no" ? translationsNo : translationsEn;
  }, [delayedLanguage]);

  return { t };
}
